import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

function DateSelectComponent({
  value,
  useMonthYear = false,
  defaultValue,
  allowClear = true,
  popupContainer,
  picker,
  ...rest
}) {
  if (useMonthYear && value && picker !== "year") {
    value = moment(value, "YYYYMM");
  } else if (picker === "year" && value) {
    value = moment(String(value), "YYYY");
  }
  const onChange = (x) => {
    if (!x) rest.onChange(null);
    else if (picker === "year") {
      rest.onChange(parseInt(x.format("YYYY")));
    } else if (useMonthYear) {
      rest.onChange(parseInt(x.format("YYYYMM")));
    } else {
      rest.onChange(x && x.toDate());
    }
  };
  const formatParsers = [
    "DD/MM/YY",
    "DD/MM/YYYY",
    "D/M/YY",
    "D/M/YYYY",
    "DD-MM-YY",
    "DD-MM-YYYY",
    "D-M-YY",
    "D-M-YYYY",
    "DD MM YY",
    "DD MM YYYY",
    "D M YY",
    "D M YYYY",
  ];

  try {
    if (typeof value === "string" && value.split) {
      const spliter = value.split("T");
      if (spliter.length > 1) {
        value = spliter[0];
      }
    }
  } catch {}

  return (
    <DatePicker
      {...rest}
      picker={picker}
      key={value || defaultValue}
      allowClear={allowClear}
      onChange={onChange}
      defaultValue={value ? moment(value) : defaultValue || null}
      format={[rest.format || "LL", ...formatParsers]}
      getPopupContainer={(t) => popupContainer || t.parentNode}
    />
  );
}

export default DateSelectComponent;
